export default "__VITE_ASSET__C$aiHDXV__"